var atomicsMapAddress = {
    Address: ['relative', 'w-px-220'],
    tab: ['absolute', 'w-px-480', 'shadow-md', 'mt-px-2', 'pt-px-4', 'z-10', 'bg-white'],
    tabBtn: ['flex', 'h-px-32', 'px-px-16', 'cursor-pointer', 'items-center'],
    active: ['border', 'border-gray-400', 'border-solid', 'bg-white', 'text-brand-600', 'border-b-0'],
    tabControl: [
        'flex',
        'text-sm',
        'items-center',
        'h-px-32',
        'border-b',
        'border-solid',
        'border-gray-400',
        'box-border',
    ],
    list: [
        'flex',
        'flex-wrap',
        'text-sm',
        'py-px-16',
        'border',
        'border-solid',
        'border-gray-400',
        'border-t-0',
    ],
    item: ['flex', 'w-px-120', 'h-px-32', 'items-center', 'cursor-pointer', 'pl-px-16', 'box-border'],
};
export default atomicsMapAddress;
